import { useEffect, useState } from 'react'

export function usePaymentsViewModel({ repository, session }) {
  const [status, setStatus] = useState('idle')
  const [methods, setMethods] = useState([])
  const [transactions, setTransactions] = useState([])
  const [error, setError] = useState(null)

  useEffect(() => {
    if (!session?.user?.id) return
    setStatus('loading')
    Promise.all([
      repository.fetchPaymentMethods(session.user.id),
      repository.fetchPaymentTransactions(session.user.id),
    ])
      .then(([methodsData, txData]) => {
        setMethods(methodsData)
        setTransactions(txData)
        setStatus('loaded')
      })
      .catch((err) => {
        setError(err.message ?? 'Failed to load payments')
        setStatus('failed')
      })
  }, [repository, session])

  return { status, methods, transactions, error }
}
